<template>
  <div class="cl-inner">
    <div class="list-oper">
      <a-button type="primary" icon="plus" @click="$refs.permissionForm.init('add')">新建</a-button>
    </div>

    <!-- 表格数据 -->
    <a-table
        :columns="columns"
        :dataSource="permissionList"
        :rowKey="record => record.id"
        class="c-table"
        :pagination="pagination"
        :loading="loading"
        @change="tableChange"
    >
      <span slot="id"></span>
      <span slot="institutionName"></span>
      <span slot="address" slot-scope="text,record">
        <template>
          <span>{{record.provinceId | codeFilter}}</span>
        </template>
      </span>
      <span slot="gmtCreate"></span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="$refs.permissionForm.init('update',record)">修改</a>
          <a-divider type="vertical"/>
          <a @click="deletePermission(record)">删除</a>
        </template>
      </span>
    </a-table>
    <permission-form-modal ref="permissionForm" @addPermissione="addPermissione"></permission-form-modal>
  </div>
</template>
<script>
  import CTable from "../../components/CTable";

  import person from "../../api/person";

  import permission from "../../api/permission";

  import PermissionFormModal from "./PermissionFormModal";

  import {analysisAddress} from "../../utils/address";

  const columns = [
    {
      title: "权限名称",
      dataIndex: "permName",
      key: "permName"
    },
    {
      title: "权限编码",
      dataIndex: "permCode",
      key: "permCode"
    },
    {
      title: "显示优先级",
      dataIndex: "priority",
      key: "address",
    },
    {
      title: "菜单路径",
      dataIndex: "path",
      key: "path",
    },
    {
      title: "创建时间",
      dataIndex: "gmtCreate",
      key: "gmtCreate",
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      scopedSlots: {customRender: "action"}
    }
  ];

  export default {
    name: "PermissionList",
    data() {
      return {
        permissionList: [], //角色的数据
        columns, //列标识数据
        queryParam: {}, //查询参数
        pagination: { 
				showTotal: total => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
        loading: true,//表格刷新
        queryParams:{}//用于改变数据时的查询参数

      };
    },
    components: {
      CTable,
      PermissionFormModal
    },
    methods: {
      //table发生该表，分页，排序
      tableChange(pagination, filters, sorter) {
        //如果查询有地址的话，把地址解析之后带入
        let obj = analysisAddress(this.queryParam);
        obj.currentPage = pagination.current;
        //存在排序的时候
        if (sorter && sorter.columnKey) {
          obj.sorter = `${sorter.columnKey}-${
            sorter.order == "ascend" ? "asc" : "desc"
            }`;
        }
        this.queryParams = obj
        this.getAccPermissionList(obj);
      },

      //新增或修改一个角色时调用
      addPermissione(value) {
        if(value&&value.parentId!=0&&this.permissionList.length==1){
          this.queryParams.currentPage = this.queryParams.currentPage-1
        }
        //查询表格的权限数据
        this.getAccPermissionList(this.queryParams);
      },

      //删除角色
      deletePermission(value) {
        let self = this;
        this.$confirm({
          title: "确定要删除吗?",
          okText: "确定",
          cancelText: "取消",
          content: "删除后，无法撤销",
          onOk() {
            permission.deletePermission(value.id).then(res => {
              //如果是这页的最后一条数据则回到上一页
              if(self.permissionList.length==1){
                self.queryParams.currentPage = self.queryParams.currentPage-1
              }
              //查询表格的权限数据
              self.getAccPermissionList(self.queryParams);
            });
          }
        });
      },

      //查询角色
      searchPermission() {
        let obj = analysisAddress(this.queryParam);
        this.getAccPermissionList(obj);
      },

      //角色列表
      getAccPermissionList(params) {
        this.loading = true;
        permission.getAccPermissionList(params).then(res => {
          this.permissionList = res.data.list;
          this.loading = false;
          //分页信息
          this.pagination = res.data.pagination;
        });
      },
    },

    created() {
      //查询表格的权限数据
      this.getAccPermissionList();
    }
  };
</script>
<style lang="scss" scoped>
  @import "src/config/var";

  .cl-inner {
    width: calc(100% - 40px);
    padding: 20px;
    background: white;
    margin: 20px auto;
  }

  .search-oper {
    button {
      margin: 0px 5px;
    }
  }

  .list-oper {
    margin: 20px 0px 30px;
  }

  .role-list-title {
    font-size: 25px;
    font-weight: bold;
    height: 39px;
  }
</style>